import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/components/Login'
import application from './controllers/ApplicationController'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { allowAnonymous: true }
    },
    {
      name: 'logout',
      path: '/logout',
      component: function () { 
        return import('@/views/Logout.vue');
      },
      meta: { allowAnonymous: true }
    },
    {
      name: 'admin',
      path: '/admin',
      component: function () { 
        return import('@/views/Admin.vue');
      },
      meta: { allowAnonymous: false }
    }

		// {
		//   path: '/about',
		//   name: 'about',
		//   // route level code-splitting
		//   // this generates a separate chunk (about.[hash].js) for this route
		//   // which is lazy-loaded when the route is visited.
		//   component: function () { 
		//     return import(/* webpackChunkName: "about" */ './views/About.vue')
		//   }
		// }
  ]
});



/**
 * Handle all routes to check for login
 * See https://scotch.io/tutorials/vue-authentication-and-route-handling-using-vue-router
 */
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.allowAnonymous)) {
    next();
  } 
  else if (sessionStorage.getItem('jwt') == null) {
    next({
      path: '/login',
      params: { nextUrl: to.fullPath }
    })
  } 
  else {
       next()
  }
})

export default router